import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EngineerTasksForm from './engineerTasksForm';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import { getCitiesList, siteByCity, createTask, subHardwareDropdown } from 'services/redux/networkEngineer/action';
import {getSiteData} from "../../../services/redux/DistanceCalculator/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    siteDetails: state.NetEnggReducer.siteDetails,
    subHardwareDropdownList:state.NetEnggReducer.subHardwareDropdownList,
    createTaskResponse: state.NetEnggReducer.createTask,
    siteDetailsList: state.leadDataReducer.siteData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic, 
            getCitiesList,
            siteByCity,
            createTask,
            getSiteData,
            subHardwareDropdown
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(EngineerTasksForm);